import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import {
  HttpService,
  SessionService,
  TableConfiguration,
  TableColumns,
  MessageService,
  FunctionsService,
  LocalStorageService,
  MenuBreadCrumb,
  params,
} from 'brainloper-ui';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Equipment } from 'src/app/models/maintenance/equipment';
import { Router } from '@angular/router';
import { EquipmentType } from 'src/app/models/maintenance/equipment-type';
import { Activity } from 'src/app/models/maintenance/activity';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { Resources } from 'src/app/models/maintenance/resources';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatStepper } from '@angular/material/stepper';
import { Location } from '@angular/common';
import { Item } from 'src/app/models/inventory/item';
import { ResourcesBulk } from 'src/app/models/maintenance/resources-bulk';
import { SizePicture } from 'src/app/models/commos/size-pircture';
import { InputOrOutputInventory } from 'src/app/models/inventory/input-or-output-inventory';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { HistoryInventory } from 'src/app/models/inventory/history-inventory';
import { ItemComboLength } from 'src/app/models/inventory/item-combo-length';
import { Data } from 'src/app/models/commos/base-response-data';

@Component({
    selector: 'app-activitie-detail',
    templateUrl: './activitie-detail.component.html',
    styleUrls: ['./activitie-detail.component.scss'],
    standalone: false
})

export class ActivitieDetailComponent implements OnInit {


  @ViewChild('stepper') stepper: MatStepper;

  urlTableEquipments: string = `${EndpointDictionary.Equipment.EQUIPMENT_TABLE}`;
  private urlGetDetailEquipment: string = `${EndpointDictionary.Equipment.CRUD_EQUIPMENT_DATA}`;
  private urlPostActivity: string = `${EndpointDictionary.Activity.CRUD_ACTIVITY_DATA}`; //Delete,Update,Post
  urlTableEquipmentType: string = `${EndpointDictionary.EquipmentType.EQUIPMENT_TYPE_TABLE}`;
  private urlAllEquipments: string = `${EndpointDictionary.Equipment.GET_ALL}`;
  urlGetTableResourcesActivity: string = `${EndpointDictionary.ResourcesActivity.RESOURCES_ACTIVITY_TABLE}`;
  urlCrudResourcesActivity: string = `${EndpointDictionary.ResourcesActivity.CRUD_RESOURCES_ACTIVITY_DATA}`;
  public urlGetItems: string = `${EndpointDictionary.Item.ITEM_COMBO}`;
  resources: Item[] = []

  paramsResources: params[] = [{ id: 'activityId', value: '0' }]
  public companyId:number
  sizePicture: SizePicture;
  isChecked: boolean = false;

  movil: boolean;

  formRegistry: UntypedFormGroup;
  selected = new UntypedFormControl(0);

  //Tabla equipos
  recargarTablaEquipos = new EventEmitter<any>();
  configurationEquipos: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    addPer: false,
    editPer: false,
    primaryKey: 'id',
  };
  columnasEquipos: TableColumns<Equipment>[] = [
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'brand',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  //Tabla TIpo Equipos
  recargarTablaTipoEquipo = new EventEmitter<any>();
  configurationTipoEquipo: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    addPer: false,
    editPer: false,
    primaryKey: 'id',
  };
  columnasTipoEquipo: TableColumns<EquipmentType>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
  ];

  //Tabla Recursos
  resourcesRequest: Array<InputOrOutputInventory> = []
  reloadResouces = new EventEmitter<any>();
  configurationResouces: TableConfiguration = {
    edit: true,
    add: true,
    delete: true,
    selectable: true,
    primaryKey: 'id',
  };

  columnsResouces: TableColumns<Item>[] = [
    {
      ID: 'itemName',
      label: 'Nombre',
      type: 'combo',
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },
      required: true,
      paramsCombo: {
        selectionField: 'id',
        visibleField: 'itemName',
        urlParams: [],
        url: `${EndpointDictionary.Item.ITEM_COMBO}`,
      }
    },
    {
      ID: 'unitMeasurement',
      label: 'Unidad',
      type: 'text',
      disregardForAdd: true,
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },

    },
    {
      ID: 'amount',
      label: 'Cantidad',
      type: 'number',
      required: true,
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'costItem',
      label: 'Costo Item',
      disregardForAdd: true,
      disregardForEdit: true,
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'totalCostItems',
      label: 'Costo Total Item',
      disregardForAdd: true,
      disregardForEdit: true,
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
      },
    }

  ];


  redirect:string

  formStepeOne: UntypedFormGroup
  imageSrc: string = '';
  equipment: Equipment = null
  equipments: Equipment[] = []
  equipmentsByEquipmentType: Equipment[] = []
  equipmentType: EquipmentType = null

  activityForm: Activity
  activityFromByEquipmetType: Activity[] = null


  public inventoryModule: boolean
  public comboItemLength: number = 1



  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Actividades",
      router: "mantenimiento/actividades"
    },
    {
      name: "Detalle",
      current: true
    }
  ]


  constructor(
    private http: HttpService,
    private formBuilder: UntypedFormBuilder,
    private session: SessionService,
    private message: MessageService,
    private functionEter: FunctionsService,
    private storage: LocalStorageService,
    private router: Router,
    public deleteItem: DeleteGenericService,
    private location: Location
  ) {
    this.companyId = this.storage.get<number>('companyId')
    this.activityForm = this.session.getData('dataActivity');
    this.redirect = this.session.getData('redirect');
    this.inventoryModule = this.storage.get<boolean>('inventory_module')
      this.formStepeOne = this.formBuilder.group({
        id: null,
      }),

      this.formRegistry = this.formBuilder.group({
        description: '',
        resources: '',
        odometerFrequency: '',
        timeFrequency: '',
        odometerLastMtto: '',
        lastMttoDate:'',
        componentId: null,
        cost: 0
      });
  }

  async ngOnInit() {
    this.movil = screen.width > 600 ? false : true;
    this.picture();

    if (this.redirect == 'new') {
      this.equipments = await this.http.getDataBody(
        `${this.urlAllEquipments}`,
        [
          { id: 'state', value: 1 }
        ]
      );
    }

    if (this.redirect == 'edit') {
      this.startFields()
    }
  }


  async startFields() {
    this.paramsResources = [{ id: 'activityId', value: this.activityForm.id}]
    this.reloadResouces.emit()

    await this.clickRowEquipment({ id: this.activityForm.equipmentId })

    for (let controls of Object.keys(this.formRegistry.controls)) {
      if (this.activityForm[controls] != null) {
        this.formRegistry.get(controls).setValue(
          this.activityForm[controls]
        );
      }
    }

    let fecha = this.functionEter.dateIso(this.activityForm.lastMttoDate)
    this.formRegistry.get('lastMttoDate').setValue(`${fecha}T08:00:00.000Z`)
  }

  picture() {

    let sizeW = ((screen.height + screen.width) / 2) * 0.2
    let sizeH = ((screen.height + screen.width) / 2) * 0.15

    this.sizePicture = {
      width: `${sizeW}px`,
      height: `${sizeH}px`,
      margin: '3px',
      visibility: 'hidde',
    };
  }

  async clickRowEquipment($event: Equipment) {
    this.message.openLoading('Cargando', 'Cargando información')
    var res:Equipment[] = await this.http.getDataBody(
      `${this.urlGetDetailEquipment}/${$event.id}`
    );
    if(res) this.equipment = res[0]
    this.imageSrc = `${EndpointDictionary.Base._BASE_URL_V2}${this.equipment.photo}/${this.companyId}`;
    this.sizePicture['visibility'] = 'visible';
    this.formStepeOne.get('id').setValue(this.equipment.id)

    this.equipment.components.unshift({
      id: 0,
      name: this.equipment.code
    })

    if (this.equipment.components.length == 1) {
      this.formRegistry.get('componentId').setValue(0)
    }
    this.equipmentType = null
    this.message.closeLoading()
  }

  async changeToggle($event: MatSlideToggleChange) {
    this.isChecked = $event.checked;
    this.formStepeOne.get('id').setValue(null);
  }

  async clickRowEquipmentType($event: EquipmentType) {
    this.equipmentType = $event;
    this.equipment = null;
    this.equipmentsByEquipmentType = this.equipments?.filter(x => x.equipmenTypeId == $event.id);
    this.formStepeOne.get('id').setValue($event.id);
    this.activityFromByEquipmetType = this.equipmentsByEquipmentType.map(equipment => ({
      equipmentId: equipment.id,
      componentId: 0,
      odometerLastMtto: '',
      lastMttoDate: null,
    }));

    if(this.activityFromByEquipmetType.length == 0){
      this.message.Info("Información", `El tipo de equipo ${$event.name} no tiene equipos asociados`)
      this.formStepeOne.get('id').setValue(null);
    }


  }

  async saveForm(form: Activity) {
    if (!this.isChecked) {
      form.equipmentId = this.equipment.id
      form.lastMttoDate = this.functionEter.dateForm(form.lastMttoDate)

      if (this.redirect == 'edit') {

        form.id = this.activityForm.id
        let res: GenericResponse = await this.http.putDataBody(
          `${this.urlPostActivity}`,
          form
        );
        if (res) {
          this.message.closeLoading();
          this.message.SuccessToast('Actividad actualizada correctamente');
          this.router.navigate(['/mantenimiento/actividades'])
        }
        return
      }

      if (!this.inventoryModule) {
        await this.createActivity(form)
        return
      }

    }
    this.activityForm = form
    this.stepper.next()
  }

  errorForm() {
    this.message.Error('Error', 'Complete los campos');
  }

  async createActivity(form: Activity) {
    this.message.openLoading('Cargando', 'Creando actividad');
    let res: GenericResponse = await this.http.postDataBody(
      `${this.urlPostActivity}`,
      form
    );
    this.message.closeLoading()
    this.message.SuccessToast(`${res['message']}`);
    this.router.navigate(['/mantenimiento/actividades'])

  }

  public async createActivityBulk() {
    if (this.activityFromByEquipmetType.find(x => x.lastMttoDate == null)) {
      this.message.Error('Error', 'Complete los campos')
      return
    }
    this.message.openLoading('Cargando', 'Creando actividades');

    const requests = this.activityFromByEquipmetType.map(element => {
      element.lastMttoDate = this.functionEter.dateForm(element.lastMttoDate)
      element.resourcesInventory = this.activityForm.resourcesInventory
      element.odometerFrequency = this.activityForm.odometerFrequency
      element.timeFrequency = this.activityForm.timeFrequency
      element.cost = this.activityForm.cost
      element.description = this.activityForm.description
      element.resources = this.activityForm.resources

      return this.http.postDataBody<GenericResponse>(`${this.urlPostActivity}`, element);
    });

    const responses = await Promise.all(requests);
    if (!responses.find(x => x == null)) {
      this.message.closeLoading()
      this.message.SuccessToast(`${responses[0]['message']}`);
      this.router.navigate(['/mantenimiento/actividades'])
    }

  }

  async createActivityWithResources($event: HistoryInventory) {
    this.activityForm.resourcesInventory = $event?.items

    if (!this.isChecked) {
      this.createActivity(this.activityForm)
      return
    }

    this.stepper.next()

  }

  comboItemsLength($event: ItemComboLength) {
    if ($event.length == 0)
      this.inventoryModule = false
  }



  async deleteResources($event: Array<any>) {
    await this.deleteItem.deleteD($event, this.urlCrudResourcesActivity, "id", "Recurso", "Recursos")
    this.reloadResouces.emit()
  }

  async addResources($event) {
    if(this.resources.find(x => x.itemInventoryId == $event.itemName)){
      this.message.ErrorToast("El recurso ya ha sido agregado")
      return
    }

    let body: ResourcesBulk = {
      activityId: this.activityForm.id,
      items: [{
        id: $event.itemName,
        amount: $event.amount
      }]
    }

    if (body.items.find(x => !x.id || !x.amount || x.id.toString() == '' || x.amount.toString() == '' || x.amount.toString() == '0')) {
      if (body.items[0].amount <= 0) {
        this.messageValidateAmout()
      }
      return
    }

    this.message.openLoading('Guardando', 'Agregando recurso')

    let res = await this.http.postDataBody<GenericResponse>(this.urlCrudResourcesActivity, body)
    if (!res) {
      this.message.ErrorToast("Error agregando recurso")
    }
    this.reloadResouces.emit()

    this.message.closeLoading()
  }

  async editResources($event) {
    let body: Resources = {
      activityId: this.activityForm.id,
      itemId: $event.old.itemInventoryId,
      amount: $event.new.amount,
      id: $event.old.id
    }

    if (body.amount <= 0) {
      this.messageValidateAmout()
      return
    }

    this.message.openLoading('Guardando', 'Editando recurso')

    let res = await this.http.putDataBody<GenericResponse>(this.urlCrudResourcesActivity, body)
    if (!res) {
      this.message.ErrorToast("Error editando recurso")
    }
    this.reloadResouces.emit()

    this.message.closeLoading()
  }


  async dataResources($event:Data<Item[]>) {
    this.resources = $event.data
  }

  private messageValidateAmout() {
    this.message.Error('Error', 'La cantidad debe ser mayor a 0')
  }

  back($event: MouseEvent) {
    $event.preventDefault()
    setTimeout(() => {
      this.location.back()
    }, 500);
  }

  async deleteActivity($event: MouseEvent) {
    $event.preventDefault()
    await this.deleteItem.deleteD([this.activityForm], this.urlPostActivity, "id", "Actividad ", "Actividades")
    this.location.back()
  }

  ngOnDestroy() {
    this.session.setData('redirect', null)
    this.session.setData("dataActivity", null)
  }


}
